import React from "react";
import { Row, Spin, Col, DatePicker, Space, message, Radio } from "antd";
import "./SalaryByMonthPage.css";
import { useState } from "react";
import { useEffect } from "react";
import CommonDivWidget from "components/CommonDivWidget/CommonDivWidget";
import moment from "moment";
import CommonButton from "components/ButtonWidgets/CommonButton/CommonButton";
import { apiSalaryByMonthPage } from "services/reportService";
import TableWidget from "./TableWidget/TableWidget";
import jsPDF from "jspdf";
import "jspdf-autotable";
import ReactExport from "react-export-excel";
import { empty, getCurrencyInfo, isEmpty } from "utils/GlobalFunctions";
// import { read, writeFileXLSX } from "xlsx";
// import { set_cptable } from "xlsx";
// import * as cptable from 'xlsx/dist/cpexcel.full.mjs';
// set_cptable(cptable);
import * as XLSX from "xlsx";
import { apiGetSalaryByMonthList } from "services/salaryService";

const { RangePicker } = DatePicker;
const dateFormat = "YYYY-MM-DD";
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
function SalaryByMonthPage(props) {
  const [isBusy, setIsBusy] = useState(false);
  const [dataList, setDataList] = useState([]);
  const { reload_random } = props;

  useEffect(() => {
    apiGetSalaryByMonth();
  }, [reload_random]);

  const apiGetSalaryByMonth = () => {
    setIsBusy(true);
    apiGetSalaryByMonthList()
      .then((data) => {
        setIsBusy(false);
        prepareData(data);
      })
      .catch((err) => {
        setIsBusy(false);
        prepareData([]);
        message.error(err);
      });
  };

  var groupBy = function (xs, key) {
    return xs.reduce(function (rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  };

  const prepareData = (data) => {
    let group_data = groupBy(data, "month_date");
    var result = [];
    Object.keys(group_data).forEach(function (key) {
      let tmpList = group_data[key];
      let tmp = 0;
      for (let i = 0; i < tmpList.length; i++) {
        tmp = tmp + parseFloat(tmpList[i].month_salary);
      }
      result.push({ id: key, items: tmpList, salary: tmp });
    });
    setDataList(result);
  };

  return (
    <CommonDivWidget>
      <Spin spinning={isBusy}>
        <div>
          {empty(dataList) ? (
            <>
              <div style={{ marginTop: 30 }}>
                <TableWidget dataList={[]} />
              </div>
            </>
          ) : (
            <TableWidget dataList={dataList} />
          )}
        </div>
      </Spin>
    </CommonDivWidget>
  );
}

export default SalaryByMonthPage;
